import React from "react";
import Tooltip from "react-native-walkthrough-tooltip";
import { AppColors } from "../../../utility/AppColors";
import {
  Image,
  Text,
  TouchableHighlight,
  TouchableOpacity,
  View,
} from "react-native";
import ImageComponent from "../../ImageComponent";
import { AppImages } from "../../../utility/AppImages";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { useTooltips } from "../../../context/WalkthroughContext";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Separator from "../../Separator";
import CreateEventComponent from "../../home-common-components/CreateEventComponent";
import { CropImage } from "../../choose-avatar-components/CropImage";
import Avatar from "../../choose-avatar-components/Avatar";

const GetTicketWalkthrough = () => {
  const {
    ticketEventTooltipVisible,
    setTicketEventTooltipVisible,
    setSidebarTopTooltipVisible,
    setHomeWalkThroughVisible,
    currentStep,
    totalSteps,
    handleNextStep,
  } = useTooltips();
  const deviceSize = useDeviceSize();

  return (
    <Tooltip
      isVisible={ticketEventTooltipVisible}
      contentStyle={{
        backgroundColor: AppColors.purple_453B50,
        width:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 350
            : 736,
        borderColor: AppColors.white,
        shadowColor: "rgba(255, 255, 255, 0.65)",
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.65,
        shadowRadius: 10.1,
        elevation: 5,
        borderWidth: 1,
      }}
      displayInsets={{
        top: 100,
        bottom:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 0
            : 400,
        left:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 0
            : deviceSize === DEVICE_SIZES.MD
            ? 50
            : 100,
        right: 0,
      }}
      arrowStyle={{
        display: "none",
      }}
      content={
        <View>
          <View
            style={{
              flexDirection:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? "column"
                  : "row",
              gap: 10,
            }}
          >
            <TouchableOpacity
              onPress={() => {
                setTicketEventTooltipVisible(false);
                setHomeWalkThroughVisible(false);
              }}
              style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}
            >
              <ImageComponent
                url={AppImages.icCloseWhiteSvg}
                style={{
                  height: 16,
                  width: 16,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
            <View
              style={{
                gap: 10,
                alignItems:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? "center"
                    : "flex-start",
                ...(deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM
                  ? { flexDirection: "row" }
                  : { width: "25%" }),
              }}
            >
              <View style={{ gap: 8 }}>
                <Avatar
                  src="https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                  variant="walkthroughPlayer"
                />
                {deviceSize === DEVICE_SIZES.XS ||
                  (deviceSize === DEVICE_SIZES.SM ? null : (
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { lineHeight: 21 },
                      ]}
                    >
                      <Text style={{ color: AppColors.green_00FFE8 }}>
                        Pro Tip :{" "}
                      </Text>
                      Ticketed events bring exclusive content and allow you to
                      engage in the ultimate spectator experience!
                    </Text>
                  ))}
              </View>
              {deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM ? (
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_12,
                    { color: AppColors.white },
                  ]}
                >
                  🎟 Get Tickets for Exclusive Events 🎟
                </Text>
              ) : null}
            </View>
            <View
              style={{
                flex: 1,
                marginTop:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 0
                    : 12,
              }}
            >
              <View style={{ gap: 10 }}>
                {deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ? null : (
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_16,
                      { color: AppColors.white }, // Set text color for better readability
                    ]}
                  >
                    🎟 Get Tickets for Exclusive Events 🎟
                  </Text>
                )}
                <View>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { lineHeight: 21 },
                    ]}
                  >
                    Want access to premium, high-stakes battles? Exclusive
                    Events are for ticket holders only—giving you front-row
                    access to intense matchups and private competitions.
                  </Text>
                  <View>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { lineHeight: 21 },
                      ]}
                    >
                      <Text style={{ color: AppColors.green_00FFE8 }}>
                        Find Exclusive Events:{" "}
                      </Text>
                      Look in the Events list for ticketed battles you don’t
                      want to miss.
                    </Text>

                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { lineHeight: 21 },
                      ]}
                    >
                      <Text style={{ color: AppColors.green_00FFE8 }}>
                        Secure Your Spot:{" "}
                      </Text>
                      Buy a ticket to get access to the action.
                    </Text>

                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { lineHeight: 21 },
                      ]}
                    >
                      <Text style={{ color: AppColors.green_00FFE8 }}>
                        Engage Like a VIP:{" "}
                      </Text>
                      Join the live chat, support players with gifts, and
                      experience the ultimate spectator event.
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View
            style={{
              gap: 10,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: 10,
            }}
          >
            <Text
              style={{
                ...AppFontStyle.REGULAR_ANYBODY_12,
                color: AppColors.green_00FFE8,
              }}
            >
              {currentStep + 1} / {totalSteps}
            </Text>

            <TouchableOpacity
              onPress={() => {
                setTicketEventTooltipVisible(false);
                setSidebarTopTooltipVisible(true);
                handleNextStep();
              }}
              style={{
                backgroundColor: AppColors.appViolentColor_6D08C3,
                width: 70,
                height: 20,
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 10,
                cursor: "pointer",
                shadowColor: "rgba(0, 0, 0, 0.25)",
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.25,
                shadowRadius: 4,
                elevation: 4,
              }}
            >
              <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
            </TouchableOpacity>
          </View>
        </View>
      }
      placement="top"
    ></Tooltip>
  );
};

export default GetTicketWalkthrough;
